export interface GroupRequestApi {
  learningPathId: string;
  groupName: string;
}

export class GroupRequestImpl implements GroupRequestApi {
  learningPathId: string;
  groupName: string;

  constructor(group: GroupRequestApi) {
    this.learningPathId = group.learningPathId;
    this.groupName = group.groupName;
  }
}
